
class ParallaxObj
{
  // ---------------------------------------------------------------------------------------------------------
	// --	ParallaxObj
	// ---------------------------------------------------------------------------------------------------------

  constructor(target)
  {
    //ターゲット保持
    this.target = target

    //パララックスのレートを保持
    this.paraRange = target.data().range

    //下の位置を保存
    this.orgTop = this.target.offset().top
    this.orgBottom = this.orgTop + this.target.height()
  }

  update(scrollY)
  {
    //判定用スクロール範囲
    const scrollRange = $(window).innerHeight() + this.target.height() + this.paraRange

    //パララックスの割合
    const currentTop = -(this.target.offset().top - scrollY - $(window).innerHeight())
    let rate = currentTop/scrollRange
    if(rate < 0) rate = 0
    if(rate > 1) rate = 1

    //位置更新
    gsap.set(this.target, {y:this.paraRange * rate})
  }
 
  // ---------------------------------------------------------------------------------------------------------
}

export default ParallaxObj
